import type { BoxProps } from '@mui/material/Box';
import type { Breakpoint } from '@mui/material/styles';

import Box from '@mui/material/Box';
import { layoutClasses } from '../../helpers/utils';


// ----------------------------------------------------------------------

type MainLayoutProps = BoxProps & {
  layoutQuery: Breakpoint;
};

export function MainLayout({ children}: MainLayoutProps) {
    return (
      <Box
        component="main"
        className={layoutClasses.main}
        sx={{
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column',
          padding: "10px",
          paddingTop: 0
        }}
     
      >
        {children}
      </Box>
    );
  }
